import React, { useState } from "react";
import logohomemenu from "../../assets/svg/tns-logo-2.0.svg";
import BannerLogin from "../../assets/svg/bg-login.svg";
import PortalModal from "../../Portals";
import {
  LoginContent,
  ImgLogoTPHomeMenu,
  ContentTerm,
  InfoTermsAndConditions,
  HeaderContentTerm,
  LeftPanel,
  RightPanel,
  LogoContainer,
  FormContainer,
  ContentTermsConditions,
  VersionContainer,
  BoxContainer,
  UserInfoContainer,
} from "./LoginPage.styled";
import CloseIcon from "@material-ui/icons/Close";
import LoginPageForm from "../LoginPageForm";
import LoginPageVerify from "../LoginPageVerify";
import UserNoticeModal from "../UserNoticeModal/UserNoticeModal";
import PropTypes from "prop-types";

const LoginPage = ({
  handleInput,
  handleChange,
  SignIn,
  SignInVerify,
  handleLogin,
  termsAndConditions,
  manualTwoFactor,
  showVerify,
  codeQR,
  existsQR,
  code,
}) => {
  const [authenticationMethod, setAuthenticationMethod] = useState(2);
  const [showTermsandConditions, setShowTermsandConditions] = useState(false);
  const [showManualTwoFactor, setShowManualTwoFactor] = useState(false);
  const [showUserNotice, setShowUserNotice] = useState(false);

  let renderTitleTwoFactor = () => {
    let parser = new DOMParser();
    let doc = parser.parseFromString(manualTwoFactor, "text/html");
    return doc.body.outerHTML;
  };
  let renderTitle = () => {
    let parser = new DOMParser();
    let doc = parser.parseFromString(termsAndConditions, "text/html");
    return doc.body.outerHTML;
  };

  function handleClose() {
    setShowUserNotice(false);
  }

  return (
    <LoginContent>
      <LeftPanel>
        <LogoContainer>
          <ImgLogoTPHomeMenu srclogo={logohomemenu}></ImgLogoTPHomeMenu>
        </LogoContainer>
        <FormContainer>
          <BoxContainer>
            {showVerify ? (
              <LoginPageVerify
                handleInput={handleInput}
                handleChange={handleChange}
                SignInVerify={SignInVerify}
                codeQR={codeQR}
                existsQR={existsQR}
                authenticationMethod={authenticationMethod}
                code={code}
                setShowManualTwoFactor={setShowManualTwoFactor}
              />
            ) : (
              <LoginPageForm
                handleInput={handleInput}
                SignIn={SignIn}
                handleLogin={handleLogin}
                authenticationMethod={authenticationMethod}
                setAuthenticationMethod={setAuthenticationMethod}
              />
            )}
          </BoxContainer>
          <ContentTermsConditions>
            <p>
              By clicking the "Login" button you agree to the{" "}
              <span onClick={() => setShowTermsandConditions(true)} onKeyDown={() => setShowTermsandConditions(true)} >
                Terms and conditions
              </span>{" "}
              and the privacy notice
            </p>
          </ContentTermsConditions>
          <VersionContainer>Version 3.7</VersionContainer>
        </FormContainer>
      </LeftPanel>
      <RightPanel>
        {showUserNotice && (
          <UserInfoContainer>
            <UserNoticeModal
              content="CCMS authentication will be deprecated soon! please make sure that your TPID (UPN) is updated and correct for it will be the only authentication method of your TnS Suite"
              header="Hello there!"
              onClose={handleClose}
            />
          </UserInfoContainer>
        )}
        <img src={BannerLogin} alt="login banner" />
      </RightPanel>

      {showTermsandConditions && (
        <PortalModal>
          <ContentTerm>
            <HeaderContentTerm>
              <div>Terms and Conditions</div>
              <CloseIcon onClick={() => setShowTermsandConditions(false)} />
            </HeaderContentTerm>
            <InfoTermsAndConditions>
              <div dangerouslySetInnerHTML={{ __html: renderTitle() }} />
            </InfoTermsAndConditions>
          </ContentTerm>
        </PortalModal>
      )}

      {showManualTwoFactor && (
        <PortalModal>
          <ContentTerm>
            <HeaderContentTerm>
              <div>Two-factor authentication</div>
              <CloseIcon onClick={() => setShowManualTwoFactor(false)} />
            </HeaderContentTerm>
            <InfoTermsAndConditions>
              <div
                dangerouslySetInnerHTML={{ __html: renderTitleTwoFactor() }}
              />
            </InfoTermsAndConditions>
          </ContentTerm>
        </PortalModal>
      )}
    </LoginContent>
  );
};

export default LoginPage;

LoginPage.propTypes = {
  handleInput: PropTypes.func,
  handleChange: PropTypes.func,
  SignIn: PropTypes.func,
  SignInVerify: PropTypes.func,
  handleLogin: PropTypes.func,
  termsAndConditions: PropTypes.string,
  manualTwoFactor: PropTypes.string,
  showVerify: PropTypes.bool,
  codeQR: PropTypes.string,
  existsQR: PropTypes.bool,
  code: PropTypes.string,
}